import React from 'react';
import { Link } from 'react-router-dom';
import { ASSET_BASE_URL } from '../config/constants';

function Privacy() {
  return (
    <div style={{
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    }}>
      {/* Header */}
      <header style={{
        padding: '24px',
        borderBottom: '1px solid #eee'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none'
          }}>
            <img
              src={`${ASSET_BASE_URL}/favicon.jpg`}
              alt="Bonzai"
              style={{ width: '32px', height: '32px', borderRadius: '6px' }}
            />
            <span style={{ fontSize: '20px', fontWeight: '600', color: '#333' }}>bonzai</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '48px 24px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '700',
          color: '#333',
          marginBottom: '32px'
        }}>
          Privacy Policy
        </h1>

        <p style={{ color: '#666', marginBottom: '24px', fontSize: '14px' }}>
          Last updated: January 2025
        </p>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Overview
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            Bonzai is a code visualization tool that runs entirely on your local machine. We are committed to protecting your privacy and being transparent about what data we collect.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            How Bonzai Works
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            When you run <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' }}>npx bonzai-tree</code>, a local server starts on your machine. This server reads your project's file structure to generate visualizations. All file processing happens locally on your computer—your code never leaves your machine.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Data We Collect
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            <strong>Analytics:</strong> We use Google Analytics to collect anonymous usage data about how visitors interact with our website (bonzai.dev). This includes page views, session duration, and general location data. This helps us improve the product.
          </p>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            <strong>Your Code:</strong> We do not collect, store, or transmit your source code. The Bonzai visualization tool runs entirely on your local machine.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Third-Party Services
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
            We use Google Analytics for website analytics. Google's privacy policy can be found at <a href="https://policies.google.com/privacy" style={{ color: '#3B82F6' }}>policies.google.com/privacy</a>.
          </p>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
            Contact
          </h2>
          <p style={{ color: '#444', lineHeight: '1.7' }}>
            If you have any questions about this Privacy Policy, please contact us at <a href="mailto:sanjog@bonzai.dev" style={{ color: '#3B82F6' }}>sanjog@bonzai.dev</a>.
          </p>
        </section>
      </main>
    </div>
  );
}

export default Privacy;
